var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
const SvgEngagementGradientIcon20 = _ref => {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 40 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.333 39S0 39 0 35.75s3.333-13 20-13 20 9.75 20 13S36.667 39 36.667 39H3.333ZM20 19.5c2.652 0 5.196-1.027 7.071-2.856A9.628 9.628 0 0 0 30 9.75a9.628 9.628 0 0 0-2.929-6.894A10.132 10.132 0 0 0 20 0a10.132 10.132 0 0 0-7.071 2.856A9.628 9.628 0 0 0 10 9.75a9.628 9.628 0 0 0 2.929 6.894A10.132 10.132 0 0 0 20 19.5Z",
    fill: "#4B4C6A"
  })));
};
export { SvgEngagementGradientIcon20 as ReactComponent };
export default __webpack_public_path__ + "33b4c6fde321e676f905d5181e4902d6.svg";